// @ts-nocheck
import React, { Component } from 'react';
import { withApollo } from '@apollo/client/react/hoc';

import { Loader } from '@crehana/ui';

import { METHODS } from 'Jsx/CheckoutV4/common/constants';
import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';
import { PaymentSources, CountryPrefixEnum } from 'Jsx/CheckoutV4/types';
import { CheckoutContext } from 'Jsx/CheckoutV4/Context';
import PendingOnlinePayment from 'Jsx/CheckoutV4/shared/PendingOnlinePayment';
import getCreditCardNumber, {
  validateCreditCardNumber,
} from 'Jsx/CheckoutV4/utils/creditCard/getCreditCardNumber';
import getCreditCardExpiry, {
  validateCardExpiry,
} from 'Jsx/CheckoutV4/utils/creditCard/getCreditCardExpiry';
import getCreditCardCVC, {
  validateCreditCardCVC,
} from 'Jsx/CheckoutV4/utils/creditCard/getCreditCardCVC';
import getFullName, {
  validateFullName,
} from 'Jsx/CheckoutV4/utils/getFullName';
import getIdentityDocument, {
  validateIdentityDocument,
} from 'Jsx/CheckoutV4/utils/identityDocument/getIdentityDocument';
import getPhoneNumber, {
  validatePhoneNumber,
} from 'Jsx/CheckoutV4/utils/phoneNumber/getPhoneNumber';

import Form from '../components/Form';
import { CheckoutFormProps, PayuFormStateBase } from '../../../../Stripe/types';

const { PAYU_PUBLIC_KEY } = window;

class CheckoutForm extends Component<CheckoutFormProps, PayuFormStateBase> {
  constructor(props) {
    super(props);
    this.state = {
      creditCardIssuer: undefined,
      creditCardNumber: '',
      creditCardExpiry: '',
      creditCardCVV: '',
      creditCardCVVDigits: 3,
      creditCardNumberErrorMessage: '',
      creditCardExpiryErrorMessage: '',
      creditCardCVVErrorMessage: '',
      isCreditCardNumberValid: false,
      isCreditCardExpiryValid: false,
      isCreditCardCVVValid: false,
      creditCardDigitsWithBlankSpaces: 19,
      loader: false,
      paymentError: '',
      processing: false,
      stripeToken: '',
      openPopup: false,
      isCheckedSaveCard: false,
      isFailedPayment: false,
      fullName: '',
      fullNameErrorMessage: '',
      isFullNameValid: false,
      identityDocument: '',
      identityDocumentErrorMessage: '',
      isIdentityDocumentValid: false,
      phoneNumber: '',
      phoneNumberErrorMessage: '',
      isPhoneNumberValid: false,
      paymentMutationStatus: null,
      checkedTerms: true,
      creditCardNumberFocus: true,
      creditCardExpiryFocus: false,
      creditCardCVVFocus: false,
      identityDocumentFocus: false,
      fullNameFocus: false,
      checkedNewsLetterTerms: false,
    };
  }

  onChangeFullName = event => {
    const { fullName, fullNameErrorMessage, isFullNameValid } =
      getFullName(event);

    this.setState({
      fullName,
      fullNameErrorMessage,
      isFullNameValid,
    });
  };

  onBlurFullName = event => {
    const { isFullNameValid, fullNameErrorMessage } = validateFullName({
      inputEvent: event,
      isCreditCardFullName: true,
    });

    this.setState({
      fullNameErrorMessage,
      isFullNameValid,
    });
  };

  onChangeCreditCardNumber = event => {
    const {
      isCreditCardNumberValid,
      creditCardIssuer,
      creditCardNumberMask,
      creditCardDigitsWithBlankSpaces,
      creditCardNumberErrorMessage,
    } = getCreditCardNumber(event);

    this.setState({
      creditCardDigitsWithBlankSpaces,
      creditCardIssuer,
      creditCardNumber: creditCardNumberMask,
      isCreditCardNumberValid,
      creditCardNumberErrorMessage,
      creditCardExpiryFocus: isCreditCardNumberValid,
    });
  };

  onBlurCreditCardNumber = event => {
    const { isCreditCardNumberValid, creditCardNumberErrorMessage } =
      validateCreditCardNumber(event);

    this.setState({ isCreditCardNumberValid, creditCardNumberErrorMessage });
  };

  onChageCreditCardExpiry = event => {
    const {
      creditCardExpiry,
      creditCardExpiryErrorMessage,
      isCreditCardExpiryValid,
    } = getCreditCardExpiry(event);

    this.setState({
      creditCardExpiry,
      creditCardExpiryErrorMessage,
      isCreditCardExpiryValid,
      creditCardCVVFocus: isCreditCardExpiryValid,
    });
  };

  onBlurCreditCardExpiry = event => {
    const { creditCardExpiryErrorMessage, isCreditCardExpiryValid } =
      validateCardExpiry(event);

    this.setState({ creditCardExpiryErrorMessage, isCreditCardExpiryValid });
  };

  onChangeCreditCardCVV = event => {
    const { creditCardIssuer } = this.state;
    const {
      creditCardCVV,
      isCreditCardCVVValid,
      creditCardCVVErrorMessage,
      creditCardCVVDigits,
    } = getCreditCardCVC({ eventInput: event, creditCardIssuer });

    this.setState({
      creditCardCVV,
      isCreditCardCVVValid,
      creditCardCVVErrorMessage,
      creditCardCVVDigits,
      identityDocumentFocus: isCreditCardCVVValid,
    });
  };

  onBlurCVV = event => {
    const { creditCardIssuer } = this.state;
    const {
      creditCardCVVErrorMessage,
      isCreditCardCVVValid,
      creditCardCVVDigits,
    } = validateCreditCardCVC({ eventInput: event, creditCardIssuer });

    this.setState({
      creditCardCVVErrorMessage,
      isCreditCardCVVValid,
      creditCardCVVDigits,
    });
  };

  onChangeIdentityDocument = event => {
    const {
      identityDocument,
      isIdentityDocumentValid,
      identityDocumentErrorMessage,
    } = getIdentityDocument({
      country: CountryPrefixEnum.PERU,
      inputEvent: event,
    });

    this.setState({
      identityDocument,
      identityDocumentErrorMessage,
      isIdentityDocumentValid,
      fullNameFocus: isIdentityDocumentValid,
    });
  };

  onBlurIdentityDocument = event => {
    const { isIdentityDocumentValid, identityDocumentErrorMessage } =
      validateIdentityDocument({
        inputEvent: event,
        country: CountryPrefixEnum.PERU,
      });

    this.setState({ isIdentityDocumentValid, identityDocumentErrorMessage });
  };

  onChangePhoneNumber = event => {
    const { phoneNumber, isPhoneNumberValid, phoneNumberErrorMessage } =
      getPhoneNumber({
        country: CountryPrefixEnum.PERU,
        event,
      });

    this.setState({
      phoneNumber,
      phoneNumberErrorMessage,
      isPhoneNumberValid,
    });
  };

  onBlurPhoneNumber = event => {
    const { isPhoneNumberValid, phoneNumberErrorMessage } = validatePhoneNumber(
      { country: CountryPrefixEnum.PERU, event },
    );

    this.setState({ isPhoneNumberValid, phoneNumberErrorMessage });
  };

  checkRequirementsToPay = () => {
    const { guestEmail, isGuestCheckout } = this.context;
    const {
      isCreditCardNumberValid,
      isCreditCardCVVValid,
      isCreditCardExpiryValid,
      isFullNameValid,
      isIdentityDocumentValid,
      isPhoneNumberValid,
      checkedTerms,
    } = this.state;
    let isPaymentButtonActive =
      isFullNameValid &&
      isCreditCardNumberValid &&
      isCreditCardExpiryValid &&
      isCreditCardCVVValid &&
      isIdentityDocumentValid &&
      isPhoneNumberValid &&
      checkedTerms;

    if (isGuestCheckout) {
      isPaymentButtonActive =
        isPaymentButtonActive && guestEmail && guestEmail.isEmailValid;
    }

    return isPaymentButtonActive;
  };

  verifyPublicKeys = () => {
    this.setState({ processing: false, loader: false });
    this.setState({
      paymentError: I18N_STRINGS.PUBLIC_KEY_NO_FOUND,
    });
  };

  clearTextError = () => {
    this.setState({
      creditCardNumberErrorMessage: '',
      creditCardExpiryErrorMessage: '',
      creditCardCVVErrorMessage: '',
      paymentError: '',
    });
  };

  returnErrorMessage = code => {
    switch (code) {
      case 'incorrect_cvc':
        this.setState({
          creditCardCVVErrorMessage: I18N_STRINGS.INVALID_CVC_CVV,
          isCreditCardCVVValid: false,
          openPopup: false,
        });
        break;
      case 'invalid_number':
        this.setState({
          creditCardNumberErrorMessage: I18N_STRINGS.INVALID_CARD_NUMBER,
          isCreditCardNumberValid: false,
          creditCardNumberFocus: true,
        });
        break;
      case 'incorrect_number':
        this.setState({
          // TODO move to utils
          creditCardNumberErrorMessage: I18N_STRINGS.INCORRECT_CARD_NUMBER,
          isCreditCardNumberValid: false,
          creditCardNumberFocus: true,
        });

        break;
      case 'expired_card':
        this.setState({
          creditCardNumberErrorMessage: I18N_STRINGS.EXPIRED_CARD,
          isCreditCardNumberValid: false,
          creditCardNumberFocus: true,
        });
        break;
      case 'card_declined':
        this.setState({
          creditCardNumberErrorMessage: I18N_STRINGS.CARD_DECLINED,
          isCreditCardNumberValid: false,
          isFailedPayment: true,
          openPopup: true,
          creditCardNumberFocus: true,
        });
        break;
      case 'processing_error':
        this.setState({
          paymentError: I18N_STRINGS.CATCH_MESSAGE,
          creditCardNumberFocus: true,
        });
        break;
      case 'invalid_expiry_year':
        this.setState({
          creditCardExpiryErrorMessage: I18N_STRINGS.INVALID_EXPIRATION_DATE,
          creditCardExpiryFocus: true,
        });
        break;
      case 'approve_with_id':
        this.setState({
          paymentError: I18N_STRINGS.INSUFFICIENT_FUNDS,
        });
        break;
      case 'withdrawal_count_limit_exceeded':
        this.setState({
          paymentError: I18N_STRINGS.INSUFFICIENT_FUNDS,
        });
        break;
      default:
        this.setState({
          paymentError: I18N_STRINGS.DEFAULT_PAYMENT_ERROR,
        });
    }
  };

  onClickPay = () => {
    this.clearTextError();
    const { selectedPaymentMethod } = this.context;
    const {
      creditCardNumber,
      creditCardExpiry,
      creditCardCVV,
      identityDocument,
      fullName,
    } = this.state;

    if (
      window.payU &&
      selectedPaymentMethod.title === METHODS.PAYU_PERU &&
      PAYU_PUBLIC_KEY !== 'None'
    ) {
      this.setState({ processing: true, loader: true });

      const expiry = creditCardExpiry.split('/');

      const expMonth = expiry ? expiry[0] : 0;
      const expYear = expiry ? expiry[1] : 0;

      window.payU.setCardDetails({
        number: creditCardNumber.replace(/\s+/g, ''),
        name_card: fullName,
        payer_id: '12345678',
        exp_month: expMonth,
        exp_year: `20${expYear}`,
        method: window.payU.cardPaymentMethod(creditCardNumber),
        document: identityDocument,
        cvv: creditCardCVV,
      });
      try {
        window.payU.getPaymentMethods();
        window.payU.createToken(this.PayUResponseHandler);
      } catch (error) {
        this.setState({
          paymentError: I18N_STRINGS.CATCH_MESSAGE,
          processing: false,
          loader: false,
        });
      }
    } else {
      this.verifyPublicKeys();
    }
  };

  PayUResponseHandler = response => {
    const { guestEmail, checkoutProductDetail, selectedPaymentMethod } =
      this.context;
    const {
      stripeToken,
      isCheckedSaveCard,
      creditCardCVV,
      fullName,
      identityDocument,
      creditCardNumber,
      phoneNumber,
    } = this.state;

    const payuToken = response.token;

    const variables = {
      paymentGateway: selectedPaymentMethod.paymentGatewayId,
      itemPromotionToken: checkoutProductDetail.promotionToken,
      itemType: checkoutProductDetail.type,
      itemId: checkoutProductDetail.originalId,
      stripeSafeCard:
        !checkoutProductDetail.isSubscription && isCheckedSaveCard,
      stripeToken,
      payuToken: response.error ? '' : payuToken,
      payuCvv: creditCardCVV,
      couponCode: checkoutProductDetail.couponCode,
      giftcard: checkoutProductDetail.giftcard,
      email: guestEmail ? guestEmail.email : '',
      membershipStartedDate: checkoutProductDetail.membershipStartedDate,
      fullName,
      document: identityDocument,
      cardBrand: window.payU.cardPaymentMethod(creditCardNumber),
      phoneNumber,
      deviceId: window.DEVICE_SESSION_ID || '',
      setCheckedNewsLettersTerms: this.state.checkedNewsLetterTerms,
    };

    this.setPayment(variables);
  };

  setPayment = variables => {
    const { buyNowMutation } = this.context;

    variables.paymentSource = PaymentSources.CHECKOUT_VIEW;

    buyNowMutation({ variables })
      .then(response => {
        if (response) {
          const { success, messages, redirectUrl } = response;

          const mutationStatusOrErrorCode =
            messages && messages.length > 0 ? messages[0].message : null;

          this.setState({ paymentMutationStatus: mutationStatusOrErrorCode });

          if (response && success) {
            window.location.href = redirectUrl;
          } else {
            this.setState({
              processing: false,
              loader: false,
            });
            this.returnErrorMessage(mutationStatusOrErrorCode);
          }
        }
      })
      .catch(() => {
        this.setState({
          paymentError: I18N_STRINGS.CATCH_MESSAGE,
          processing: false,
          loader: false,
        });
      });
  };

  setCheckedTerms = checked => this.setState({ checkedTerms: checked });

  setCheckedNewsLettersTerms = checked =>
    this.setState({ checkedNewsLetterTerms: checked });

  render() {
    const {
      isFailedPayment,
      openPopup,
      processing,
      paymentMutationStatus,
      checkedTerms,
      checkedNewsLetterTerms,
      ...restState
    } = this.state;
    const {
      onEmailChange,
      handleOnblurEmail,
      guestEmail,
      isGuestCheckout,
      loadingItem,
      checkoutProductDetail: { type },
    } = this.context;
    const isPaymentButtonActive = processing || this.checkRequirementsToPay();

    if (loadingItem) {
      return (
        <div className="flex justify-center w-full m-24">
          <Loader size={48} />
        </div>
      );
    }

    if (paymentMutationStatus === 'pending') {
      return <PendingOnlinePayment />;
    }

    return (
      <div className="flex flex-col w-full">
        <Form
          onChangeCreditCardNumber={this.onChangeCreditCardNumber}
          onBlurCreditCardNumber={this.onBlurCreditCardNumber}
          onChangeFullName={this.onChangeFullName}
          onBlurFullName={this.onBlurFullName}
          onChangeCreditCardCVV={this.onChangeCreditCardCVV}
          onBlurCVV={this.onBlurCVV}
          onChageCreditCardExpiry={this.onChageCreditCardExpiry}
          onBlurCreditCardExpiry={this.onBlurCreditCardExpiry}
          onChangeIdentityDocument={this.onChangeIdentityDocument}
          onBlurIdentityDocument={this.onBlurIdentityDocument}
          onChangePhoneNumber={this.onChangePhoneNumber}
          onBlurPhoneNumber={this.onBlurPhoneNumber}
          checkRequirementsToPay={this.checkRequirementsToPay}
          onClickPay={this.onClickPay}
          isPaymentButtonActive={isPaymentButtonActive}
          onEmailChange={onEmailChange}
          handleOnblurEmail={handleOnblurEmail}
          guestEmail={guestEmail}
          isGuestCheckout={isGuestCheckout}
          isMembership={type === 'membership'}
          checkedTerms={checkedTerms}
          setCheckedTerms={this.setCheckedTerms}
          checkedNewsLetterTerms={checkedNewsLetterTerms}
          setCheckedNewsLetterTerms={this.setCheckedNewsLettersTerms}
          {...restState}
          {...this.props}
        />
      </div>
    );
  }
}

CheckoutForm.contextType = CheckoutContext;

export default withApollo(CheckoutForm);
